/**
 * Utilidades de fecha compartidas para el CRM Web
 */

/**
 * Calcula el nivel de urgencia de una fecha y retorna estilos para todos los contextos:
 * - Panel (ProspectPanel/Content): sectionBg, inputBorder, message
 * - Tabla (ContactsTable): cellClass, textClass, dotClass
 * - Sidebar (ProspectSidePanel): badgeClass
 * 
 * @param {string} dateString - Fecha ISO o YYYY-MM-DD
 * @returns {object} Objeto con level, label y estilos por contexto
 */
export function getDateUrgency(dateString) {
  if (!dateString) {
    return {
      level: 'none',
      label: '',
      message: '',
      // Panel styles
      sectionBg: 'bg-gradient-to-r from-gray-50 to-slate-50',
      inputBorder: 'border-gray-300',
      // Table styles
      cellClass: '',
      textClass: 'text-gray-400 dark:text-gray-500',
      dotClass: 'bg-gray-300',
      // Sidebar styles
      badgeClass: ''
    }
  }

  try {
    const dateOnly = dateString.split('T')[0]
    const today = new Date()

    const [year, month, day] = dateOnly.split('-').map(Number)
    const targetDate = new Date(year, month - 1, day)
    const todayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate())
    const diffTime = targetDate.getTime() - todayDate.getTime()
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

    if (diffDays < 0) {
      return {
        level: 'overdue',
        label: '',
        message: 'Esta fecha ya vencio',
        sectionBg: 'bg-gradient-to-r from-red-100 via-red-50 to-rose-50 dark:from-red-900/20 dark:via-red-900/15 dark:to-rose-900/15',
        inputBorder: 'border-red-300 dark:border-red-700 bg-red-50 dark:bg-red-900/20 text-red-700 dark:text-red-300',
        cellClass: 'bg-red-100 dark:bg-red-900/30',
        textClass: 'text-gray-800 dark:text-gray-300',
        dotClass: 'bg-red-500',
        badgeClass: 'bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-300'
      }
    } else if (diffDays === 0) {
      return {
        level: 'today',
        label: '',
        message: 'Vence hoy',
        sectionBg: 'bg-gradient-to-r from-orange-100 via-amber-50 to-yellow-50',
        inputBorder: 'border-orange-300 dark:border-orange-700 bg-orange-50 dark:bg-orange-900/20 text-orange-700 dark:text-orange-300',
        cellClass: '',
        textClass: 'text-gray-800 dark:text-gray-300',
        dotClass: 'bg-orange-500',
        badgeClass: 'bg-orange-100 dark:bg-orange-900/30 text-orange-800 dark:text-orange-300'
      }
    } else if (diffDays === 1) {
      return {
        level: 'tomorrow',
        label: '',
        message: 'Vence manana',
        sectionBg: 'bg-gradient-to-r from-amber-100 via-yellow-50 to-lime-50',
        inputBorder: 'border-amber-300 bg-amber-50 text-amber-700',
        cellClass: 'bg-green-100 dark:bg-green-900/30',
        textClass: 'text-gray-800 dark:text-gray-300',
        dotClass: 'bg-amber-500',
        badgeClass: 'bg-amber-100 dark:bg-amber-900/30 text-amber-800 dark:text-amber-300'
      }
    } else if (diffDays <= 7) {
      return {
        level: 'week',
        label: '',
        message: 'Vence en ' + diffDays + ' dias',
        sectionBg: 'bg-gradient-to-r from-yellow-50 via-lime-50 to-green-50',
        inputBorder: 'border-yellow-300 bg-yellow-50 text-yellow-700',
        cellClass: 'bg-green-100 dark:bg-green-900/30',
        textClass: 'text-gray-800 dark:text-gray-300',
        dotClass: 'bg-yellow-500',
        badgeClass: 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-300'
      }
    } else if (diffDays <= 30) {
      return {
        level: 'month',
        label: '',
        message: 'Vence en ' + diffDays + ' dias',
        sectionBg: 'bg-gradient-to-r from-lime-50 via-green-50 to-emerald-50',
        inputBorder: 'border-lime-300 bg-lime-50 text-lime-700',
        cellClass: 'bg-green-50 dark:bg-green-900/20',
        textClass: 'text-gray-800 dark:text-gray-300',
        dotClass: 'bg-lime-400',
        badgeClass: 'bg-lime-100 dark:bg-lime-900/30 text-lime-800 dark:text-lime-300'
      }
    } else {
      return {
        level: 'none',
        label: '',
        message: '',
        sectionBg: 'bg-gradient-to-r from-green-50 via-emerald-50 to-teal-50',
        inputBorder: 'border-gray-300 bg-white',
        cellClass: 'bg-green-50 dark:bg-green-900/20',
        textClass: 'text-gray-600 dark:text-gray-400',
        dotClass: 'bg-gray-300',
        badgeClass: ''
      }
    }
  } catch {
    return {
      level: 'none',
      label: '',
      message: '',
      sectionBg: 'bg-gradient-to-r from-gray-50 to-slate-50',
      inputBorder: 'border-gray-300',
      cellClass: '',
      textClass: 'text-gray-400',
      dotClass: 'bg-gray-300',
      badgeClass: ''
    }
  }
}
